// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import JSZip from "jszip";
import { pqUtils, xmlPartsUtils, htmlUtils, gridUtils } from "./utils";
import { SIMPLE_BLANK_TABLE_TEMPLATE, SIMPLE_QUERY_WORKBOOK_TEMPLATE } from "./workbookTemplate";
import { defaults, emptyQueryMashupErr, blobFileType, application, templateWithInitialDataErr, tableNotFoundErr, headers, OFU } from "./utils/constants";
import { generateSingleQueryMashup } from "./generators";
export var generateSingleQueryWorkbook = function (query, initialDataGrid, fileConfigs) { return __awaiter(void 0, void 0, void 0, function () {
    var templateFile, zip, _a, tableData;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!query.queryMashup) {
                    throw new Error(emptyQueryMashupErr);
                }
                if (!query.queryName) {
                    query.queryName = defaults.queryName;
                }
                templateFile = fileConfigs === null || fileConfigs === void 0 ? void 0 : fileConfigs.templateFile;
                if (templateFile !== undefined && initialDataGrid !== undefined) {
                    throw new Error(templateWithInitialDataErr);
                }
                pqUtils.validateQueryName(query.queryName);
                if (!(templateFile === undefined)) return [3 /*break*/, 2];
                return [4 /*yield*/, JSZip.loadAsync(SIMPLE_QUERY_WORKBOOK_TEMPLATE, { base64: true })];
            case 1:
                _a = _b.sent();
                return [3 /*break*/, 4];
            case 2: return [4 /*yield*/, JSZip.loadAsync(templateFile)];
            case 3:
                _a = _b.sent();
                _b.label = 4;
            case 4:
                zip = _a;
                tableData = initialDataGrid ? gridUtils.parseToTableData(initialDataGrid) : undefined;
                return [4 /*yield*/, generateSingleQueryWorkbookFromZip(zip, query, fileConfigs, tableData)];
            case 5: return [2 /*return*/, _b.sent()];
        }
    });
}); };
export var generateTableWorkbookFromHtml = function (htmlTable, fileConfigs) { return __awaiter(void 0, void 0, void 0, function () {
    var gridData;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                gridData = htmlUtils.extractTableValues(htmlTable);
                return [4 /*yield*/, generateTableWorkbookFromGrid({ data: gridData, config: { promoteHeaders: true } }, fileConfigs)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var generateTableWorkbookFromGrid = function (grid, fileConfigs) { return __awaiter(void 0, void 0, void 0, function () {
    var zip, _a, tableData;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!((fileConfigs === null || fileConfigs === void 0 ? void 0 : fileConfigs.templateFile) === undefined)) return [3 /*break*/, 2];
                return [4 /*yield*/, JSZip.loadAsync(SIMPLE_BLANK_TABLE_TEMPLATE, { base64: true })];
            case 1:
                _a = _b.sent();
                return [3 /*break*/, 4];
            case 2: return [4 /*yield*/, JSZip.loadAsync(fileConfigs.templateFile)];
            case 3:
                _a = _b.sent();
                _b.label = 4;
            case 4:
                zip = _a;
                tableData = gridUtils.parseToTableData(grid);
                if (tableData === undefined) {
                    throw new Error(tableNotFoundErr);
                }
                return [4 /*yield*/, xmlPartsUtils.updateWorkbookDataAndConfigurations(zip, fileConfigs, tableData)];
            case 5:
                _b.sent();
                return [4 /*yield*/, zip.generateAsync({
                        type: blobFileType,
                        mimeType: application,
                    })];
            case 6: return [2 /*return*/, _b.sent()];
        }
    });
}); };
var generateSingleQueryWorkbookFromZip = function (zip, query, fileConfigs, tableData) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!query.queryName) {
                    query.queryName = defaults.queryName;
                }
                return [4 /*yield*/, xmlPartsUtils.updateWorkbookPowerQueryDocument(zip, query.queryName, generateSingleQueryMashup(query.queryName, query.queryMashup))];
            case 1:
                _a.sent();
                return [4 /*yield*/, xmlPartsUtils.updateWorkbookSingleQueryAttributes(zip, query.queryName, query.refreshOnOpen)];
            case 2:
                _a.sent();
                return [4 /*yield*/, xmlPartsUtils.updateWorkbookDataAndConfigurations(zip, fileConfigs, tableData, true /*updateQueryTable*/)];
            case 3:
                _a.sent();
                return [4 /*yield*/, zip.generateAsync({
                        type: blobFileType,
                        mimeType: application,
                    })];
            case 4: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var downloadWorkbook = function (file, filename) {
    var nav = window.navigator;
    if (nav.msSaveOrOpenBlob)
        // IE10+
        nav.msSaveOrOpenBlob(file, filename);
    else {
        // Others
        var a_1 = document.createElement("a");
        var url_1 = URL.createObjectURL(file);
        a_1.href = url_1;
        a_1.download = filename;
        document.body.appendChild(a_1);
        a_1.click();
        setTimeout(function () {
            document.body.removeChild(a_1);
            window.URL.revokeObjectURL(url_1);
        }, 0);
    }
};
export var openInExcelWeb = function (file, filename, allowTyping) { return __awaiter(void 0, void 0, void 0, function () {
    var fileContent, fileNameGuid, allowTypingParam, response, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!(file.size > 0)) return [3 /*break*/, 4];
                fileContent = file;
                fileNameGuid = new Date().getTime().toString() + (filename ? "_" + filename : "") + ".xlsx";
                allowTypingParam = allowTyping ? 1 : 0;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, fetch("".concat(OFU.PostUrl).concat(fileNameGuid), {
                        method: "POST",
                        headers: headers,
                        body: fileContent,
                    })];
            case 2:
                response = _a.sent();
                // Check if the response is successful
                if (response.ok) {
                    // if upload was successful - open the file in a new tab
                    window.open("".concat(OFU.ViewUrl).concat(fileNameGuid, "&").concat(OFU.allowTyping, "=").concat(allowTypingParam), "_blank");
                }
                else {
                    throw new Error("File upload failed. Status code: ".concat(response.status));
                }
                return [3 /*break*/, 4];
            case 3:
                error_1 = _a.sent();
                console.error("An error occurred:", error_1);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };
